"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _header = _interopRequireDefault(require("./header/"));

var _column = _interopRequireDefault(require("./header/column"));

var _body = _interopRequireDefault(require("./body/"));

var _row = _interopRequireDefault(require("./body/row/"));

var _column2 = _interopRequireDefault(require("./body/column/"));

var _empty = _interopRequireDefault(require("../empty/"));

var _checkbox = _interopRequireDefault(require("../checkbox/"));

var _reactPaginate = _interopRequireDefault(require("react-paginate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table() {
    _classCallCheck(this, Table);

    return _super.apply(this, arguments);
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.widths.length != this.props.body.row.render.length) {
        throw new Error('The number of table columns must match the length of body.render functions');
      }
    }
  }, {
    key: "onHeaderCheckboxChange",
    value: function onHeaderCheckboxChange() {
      var checkbox = this.props.header.checkbox;

      if (checkbox.onChange && typeof checkbox.onChange === 'function') {
        checkbox.onChange(!checkbox.checked);
      } else {
        throw new Error('Header Checkbox onChange is not a function.');
      }
    }
  }, {
    key: "onRowCheckboxChange",
    value: function onRowCheckboxChange(e, data, index) {
      var checkbox = this.props.body.row.checkbox;

      if (checkbox.onChange && typeof checkbox.onChange === 'function') {
        checkbox.onChange(data, index, !checkbox.checked, e);
      } else {
        throw new Error('Row Checkbox onChange is not a function.');
      }
    }
  }, {
    key: "onRowClick",
    value: function onRowClick(e, data, index) {
      var onClick = this.props.body.row.onClick;

      if (onClick && typeof onClick === 'function' && !e.ctrlKey) {
        onClick(e, data, index);
      }
    }
  }, {
    key: "onPageChange",
    value: function onPageChange(selected) {
      if (this.props.paginate.onPageChange && typeof this.props.paginate.onPageChange === 'function') {
        this.props.paginate.onPageChange(selected);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props$header = this.props.header,
          columns = _this$props$header.columns,
          sorting = _this$props$header.sorting,
          checkbox = _this$props$header.checkbox;
      var _this$props$body = this.props.body,
          data = _this$props$body.data,
          row = _this$props$body.row;
      var _this$props = this.props,
          widths = _this$props.widths,
          paginate = _this$props.paginate,
          testID = _this$props.testID;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": testID,
        className: "".concat(this.props.className || '', " __table")
      }, /*#__PURE__*/_react.default.createElement(_header.default, null, checkbox && _typeof(checkbox) === 'object' && /*#__PURE__*/_react.default.createElement("div", {
        className: "pl2 flex items-center"
      }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
        checked: checkbox.checked || false,
        indeterminate: checkbox.indeterminate,
        onChange: function onChange(e) {
          return _this.onHeaderCheckboxChange();
        },
        small: true
      })), columns.map(function (column, index) {
        return /*#__PURE__*/_react.default.createElement(_column.default, {
          key: index,
          sorting: sorting,
          onSortChange: function onSortChange(value) {
            return sorting.onSortChange(value);
          },
          anchor: index > 1 ? 'right' : 'left',
          width: widths[index],
          column: column
        });
      })), /*#__PURE__*/_react.default.createElement(_body.default, null, !data || !data.length ? /*#__PURE__*/_react.default.createElement(_empty.default, this.props.body.empty) : data.map(function (d, index) {
        return /*#__PURE__*/_react.default.createElement(_row.default, {
          checked: row.checkbox && row.checkbox.checked(d, index) || false,
          compact: row.compact || false,
          key: d._id,
          hasClickAction: row.onClick && typeof row.onClick === 'function' ? true : false,
          hasCustomRender: row.customRender && typeof row.customRender === 'function' || false,
          customRender: function customRender(children) {
            return row.customRender(children, d);
          }
        }, row.checkbox && _typeof(row.checkbox) === 'object' && /*#__PURE__*/_react.default.createElement("div", {
          className: "pl2 flex items-center __checkbox_row"
        }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
          checked: row.checkbox && typeof row.checkbox.checked === 'function' && row.checkbox.checked(d, index) || false,
          disabled: row.checkbox && typeof row.checkbox.disabled === 'function' && row.checkbox.disabled(d, index) || false,
          hidden: row.checkbox && typeof row.checkbox.hidden === 'function' && row.checkbox.hidden(d, index) || false,
          onChange: function onChange(e) {
            return _this.onRowCheckboxChange(e, d, index);
          },
          small: true
        })), widths.map(function (width, columnIndex) {
          return /*#__PURE__*/_react.default.createElement(_column2.default, {
            width: width,
            onClick: function onClick(e) {
              return _this.onRowClick(e, d, index);
            },
            key: columnIndex
          }, row.render[columnIndex](data[index]));
        }));
      })), /*#__PURE__*/_react.default.createElement("div", null, paginate && _typeof(paginate) == 'object' && data.length > 0 && paginate.pageCount > 1 && /*#__PURE__*/_react.default.createElement(_reactPaginate.default, {
        containerClassName: "flex items-stretch justify-end py2 list-style-none mt2 cs-paginate",
        previousLabel: "Back",
        forcePage: paginate.currentPage,
        pageCount: paginate.pageCount,
        pageRangeDisplayed: 5,
        marginPagesDisplayed: 2,
        breakClassName: "cs-break",
        breakLinkClassName: "a_cs-break",
        onPageChange: function onPageChange(_ref) {
          var selected = _ref.selected;
          return _this.onPageChange(selected);
        }
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Table;
}(_react.default.Component);

Table.propTypes = {
  className: _propTypes.default.string,
  widths: _propTypes.default.array.isRequired,
  testID: _propTypes.default.string,
  header: _propTypes.default.shape({
    checkbox: _propTypes.default.shape({
      checked: _propTypes.default.bool,
      onChange: _propTypes.default.func
    }),
    columns: _propTypes.default.array.isRequired,
    sorting: _propTypes.default.shape({
      onSortChange: _propTypes.default.func,
      direction: _propTypes.default.string,
      key: _propTypes.default.string
    }),
    showCheckbox: _propTypes.default.bool,
    onCheckboxChange: _propTypes.default.func
  }).isRequired,
  body: _propTypes.default.shape({
    data: _propTypes.default.array,
    row: _propTypes.default.shape({
      customRender: _propTypes.default.func,
      checkbox: _propTypes.default.shape({
        checked: _propTypes.default.func,
        onChange: _propTypes.default.func,
        disabled: _propTypes.default.func
      }),
      onClick: _propTypes.default.func,
      render: _propTypes.default.array.isRequired,
      compact: _propTypes.default.bool
    }),
    empty: _propTypes.default.shape({
      icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.object]),
      title: _propTypes.default.string,
      text: _propTypes.default.string
    })
  }).isRequired,
  paginate: _propTypes.default.shape({
    currentPage: _propTypes.default.number,
    pageCount: _propTypes.default.number,
    onPageChange: _propTypes.default.func
  })
};
var _default = Table;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Table, "Table", "/Users/darcy/sites/cs-theme/src/components/table/index.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/table/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();